import { Injectable } from '@angular/core';
import {
  MatLegacySnackBar as MatSnackBar,
  MatLegacySnackBarConfig as MatSnackBarConfig,
  MatLegacySnackBarHorizontalPosition as MatSnackBarHorizontalPosition,
  MatLegacySnackBarRef as MatSnackBarRef,
  MatLegacySnackBarVerticalPosition as MatSnackBarVerticalPosition,
  LegacyTextOnlySnackBar as TextOnlySnackBar,
} from '@angular/material/legacy-snack-bar';

const DefaultSnackbarDuration = 6000;

@Injectable({
  providedIn: 'root',
})
export class ApSnackBarService {
  defaultTimeout = DefaultSnackbarDuration;
  maxTimeout = 15000;

  undoSnackBarConfig: MatSnackBarConfig = {
    duration: DefaultSnackbarDuration,
    horizontalPosition: 'center',
    verticalPosition: 'bottom',
  };

  constructor(private snackBar: MatSnackBar) {
  }

  public showUndoSnackBar(messageText: string): MatSnackBarRef<TextOnlySnackBar> {
    return this.snackBar.open(
      messageText,
      'Undo',
      this.undoSnackBarConfig);
  }

  public showSnackBar(
    messageText: string,
    actionText: string,
    duration: number = DefaultSnackbarDuration,
    horizontalPosition: MatSnackBarHorizontalPosition = 'center',
    verticalPosition: MatSnackBarVerticalPosition = 'bottom'): MatSnackBarRef<TextOnlySnackBar> {
      // Make sure a valid duration is being passed in
      if (duration > this.maxTimeout || duration <= 0) {
        duration = this.defaultTimeout;
      }

      const snackBarConfig: MatSnackBarConfig = {
        duration: duration as number,
        horizontalPosition: horizontalPosition as MatSnackBarHorizontalPosition,
        verticalPosition: verticalPosition as MatSnackBarVerticalPosition,
      };

      return this.snackBar.open(
        messageText,
        actionText,
        snackBarConfig);
  }
}
